import { Container } from '$app/shared/components/Container';
import styled from 'styled-components';

export const ContainerStyled = styled(Container)`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
`

export const DivStyled = styled.div`
height: 100%;
padding: 8px 16px;
margin: 0;
background: #fbfbfb;

.ReactTable {
  background: #fff;
}

.ant-btn-primary {
  margin-bottom: 8px;
}
`;
